
import {
  defineComponent, onMounted, onUnmounted,
} from 'vue';
import { NETWORK_CONTACT_TYPES } from '@/types/enums';
import SpacesUser from '../components/SpacesUser.vue';
import SpacesUserTransition from '../components/SpacesUserTransition.vue';
// eslint-disable-next-line import/no-cycle
import { useSpacesStore } from '../store/spacesStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: {
    SpacesUser,
    SpacesUserTransition,
  },
  emits: ['setGroupData', 'showPopUp'],
  setup() {
    const spacesStore = useSpacesStore();

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    onUnmounted(() => {
      spacesStore.search = '';
    });

    return {
      spacesStore,
      NETWORK_CONTACT_TYPES,
    };
  },
});
